<template>
    <div class="campaign-box campaign-box--no_border" id="vue-datagrid" :data-campaign-id="campaignId">
        <div class="row">
            <div class="col-md-3">
                <h2 class="campaigns-details__adsets-title">
                    Current Ad Sets
                    <info-tooltip
                        text="This is a list of the ad sets for this campaign and their metrics respective of the date range selected above."
                        :inline="true">
                    </info-tooltip>
                </h2>
            </div>
            <div class="col-md-6 campaigns-details__adsets-total">
                <div class="pull-left" v-cloak>{{ adSets.length }} Total Ad Sets</div>
                <div class="pull-left" v-cloak>{{ totalActiveAdSets }} Active Ad Sets</div>
            </div>
        </div>
        <div class="row campaigns-details__adsets-summary">
            <div v-if="canCreateAdSet()" class="col-md-4">
                <a :href="createAdSetUrl" type="button"
                   class="btn --green-light --white-font">Create an Ad Set</a>
            </div>
        </div>
        <div v-cloak>
            <campaign-ad-set-header-row
                :chart-start-date="chartStartDate"
                :chart-end-date="chartEndDate"
                :chart-is-updating="chartIsUpdating"
                :show-product-type="showProductTypeColumn"
                :sort-by="sortBy"
                :sort-direction="orderBy"
                @sort="setSortBy">
            </campaign-ad-set-header-row>

            <campaign-ad-set-row v-for="adset in orderedAdSets"
                                 v-if="shouldShowAdSet(adset)"
                                 :key="adset.id"
                                 :ad-set="adset"
                                 :campaign-id="campaignId"
                                 :campaign="campaign"
                                 :show-product-type="showProductTypeColumn"
                                 :loading="loading"
                                 :isLive="isLive(adset.id)"
                                 :isTestMode="isTestMode(adset.id)"
                                 :show-live-status="showLiveStatus"
                                 :loading-live-status="isLoadingLiveStatus"
                                 @activate="changeAdSetStatus($event, true)"
                                 @deactivate="changeAdSetStatus($event, false)"
                                 @ignore-schedule-enabled="changeAdSetIgnoreScheduleStatus($event, false)"
                                 @ignore-schedule-disabled="changeAdSetIgnoreScheduleStatus($event, true)"
                                 @change-bid-status="changeBidStatus"
                                 @delete="deleteAdSet"
                                 @clone="cloneAdSet"
                                 v-cloak>
            </campaign-ad-set-row>
        </div>

        <disclaimer class="m-t-lg"></disclaimer>

        <modal title="Duplicate Ad Set"
               v-show="adSetCopy.show"
               ok-text="Copy"
               v-on:cancel="adSetCopy.show = false"
               v-cloak>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Ad Set Name</label>
                        <input type="text" class="form-control" dusk="copy-name" v-model="adSetCopy.name">
                        <label v-show="copyHaveNameCollision" class="error">The Ad Set Name already exists.</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <div class="form-group">
                            <label>Product Type</label>
                            <info-tooltip text='Select a product that you wish to apply to this ad set.'></info-tooltip>
                        </div>
                        <div v-for="loanPurpose in dimensions.loan_purposes" class="m-b-sm">
                            <label>
                                <input
                                    type="radio"
                                    name="loan_purposes"
                                    v-model="adSetCopy.loan_purpose"
                                    :value="loanPurpose.id"
                                ><span class="p-l-md">{{ loanPurpose.label }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <button type="button" class="btn red btn-outline" @click="adSetCopy.show = false">Cancel</button>
            </span>
        </modal>
    </div>
</template>

<script>
import get from 'lodash/get'
import store from './store'
import {mapGetters} from 'vuex'
import campaignCommon from 'js/campaigns/common'

export default {
    store,

    mixins: [campaignCommon],

    props: ['createAdSetUrl', 'campaignId', 'campaign', 'loading', 'dimensions', 'lookerAdSetData', 'vertical', 'lookerLoaded', 'featureFlags'],

    watch: {
        loading (value) {
            this.loading = value
        }
    },

    data () {
        return {
            baseUrl: window.Portal.baseUrl,
            adSetCopy: {
                id: null,
                name: '',
                loan_purpose: '',
                show: false
            },
            liveAdSets: [],
            isLoadingAllLiveAdSets: false,
            sortBy: 'is_active',
            orderBy: 'asc'
        }
    },

    computed: {
        ...mapGetters([
            'adSets',
            'chartStartDate',
            'chartEndDate',
            'chartIsUpdating'
        ]),

        showProductTypeColumn() {
            return this.vertical === 'deposits';
        },

        showLiveStatus(){
            return this.hasRole('staff') || this.hasRole('engineer');
        },

        isLoadingLiveStatus() {
            return this.liveAdSets === null;
        },

        orderedAdSets: function () {
            // so that v-for does not render
            // if (this.loading) {
            //     return []
            // }

            const sortBy = (adset) => {
                switch (this.sortBy) {
                    case 'is_active': {
                        return !adset.is_active;
                    }
                    case 'name': {
                        return adset.name.toLowerCase();
                    }
                    case 'product_type': {
                        return adset.loan_purposes[0].label;
                    }
                    default: {
                        return adset[this.sortBy];
                    }
                }
            }

            let adsets = _.map(store.getters.composedAdSets, (adSet) => {
                const decoratedAdSet = Object.assign({}, adSet);
                let lookerAdSet = _.find(this.lookerAdSetData, {adSetId: adSet.id.toString()});

                // if we didn't find a match from looker, make a stub and fallback below
                if (!lookerAdSet) {
                    lookerAdSet = {inRange: {}, today: {}}
                }

                decoratedAdSet.click_count = this.lookerLoaded ? (lookerAdSet.inRange.clicks || 0) : null;
                decoratedAdSet.placement = this.lookerLoaded ? (lookerAdSet.inRange.position || 0) : null;
                decoratedAdSet.cost = this.lookerLoaded ? (lookerAdSet.inRange.revenue || 0) : null;
                // decoratedAdSet.todays_click_count = this.lookerLoaded ? (lookerAdSet.today.clicks || 0) : null;
                // decoratedAdSet.todays_cost = this.lookerLoaded ? (lookerAdSet.today.revenue || 0) : null;

                return decoratedAdSet
            });

            return _.orderBy(adsets, [sortBy, 'name'], this.orderBy);
        },

        totalActiveAdSets: function () {
            return _.filter(this.adSets, 'is_active').length;
        },

        namesList: function () {
            const vm = this;
            return Object.keys(this.adSets).map((key) => vm.adSets[key].name.trim().toLowerCase());
        },

        copyHaveNameCollision: function () {
            return _.indexOf(this.namesList, this.adSetCopy.name.trim().toLowerCase()) !== -1;
        },

        adSetStats: function () {
            return store.getters.statsItemTotals;
        },
        isCostPerClick: function () {
            return store.getters.isCostPerClick;
        },
        isCostPerLead: function () {
            return store.getters.isCostPerLead;
        }
    },

    methods: {
        /* Ad Set */
        cloneAdSet: function (adSetId) {
            const vm = this;
            const cloneUrl = vm.baseUrl + '/campaigns/' + this.campaignId + '/adset/' + adSetId + '/clone';
            this.showConfirmMessage(null, function () {
                vm.showLoading();
                vm.$http.post(cloneUrl).then(function (response) {
                    if (response.data.success) {
                        vm.hideLoading();
                        vm.showSuccessMessage('AdSet successfully cloned', () => {
                            vm.showLoading();
                            this.redirect(this.baseUrl + '/campaigns/' + this.campaignId + '/');
                        });
                    } else {
                        vm.hideLoading();
                        vm.showErrorMessage();
                    }
                }, vm.manageErrors);
            }, 'Yes, CLONE it!');
        },

        deleteAdSet: function (id) {
            const vm = this;
            const deleteUrl = vm.baseUrl + '/campaigns/' + this.campaignId + '/adset/' + id;
            this.showConfirmMessage(null, function () {
                vm.showLoading();
                vm.$http.delete(deleteUrl).then(function (response) {
                    if (response.data.success) {
                        this.redirect(this.baseUrl + '/campaigns/' + this.campaignId + '/');
                    } else {
                        vm.hideLoading();
                        vm.showErrorMessage();
                    }
                }, vm.manageErrors);
            }, 'Yes, DELETE it!');
        },

        changeAdSetStatus: function (adSetId, status) {
            const url = `${this.baseUrl}/campaigns/${this.campaignId}/adset/${adSetId}/`;
            const oldStatus = status ? 'deactivate' : 'activate';

            store.commit('setAdSetIsActive', {
                id: adSetId,
                isActive: status // ? 0 : 1
            });

            store.commit('setIsLoading',true);
            this.$http.put(url + (status ? 'activate' : 'deactivate') + `?vertical=${this.vertical}`)
                .then((data) => {
                    // was the last active ad set turned off if so deactivate campaign toggle
                    if (data.body) {
                        store.commit('deactivateCampaignByLastAdSet', data.body.campaign_deactivated);
                    }
                    store.commit('setIsLoading', false);
                    this.fetchAllLiveAdSets();
                })
                .catch((error) => {
                    store.commit('setAdSetIsActive', {
                        id: adSetId,
                        isActive: oldStatus
                    });

                    store.commit('setIsLoading', false);
                    this.fetchAllLiveAdSets();
                    this.manageErrors(error);
                });
        },

        changeAdSetIgnoreScheduleStatus: function (adSetId, status) {
            const url = `${this.baseUrl}/api/campaign/${this.campaignId}/adset/${adSetId}/${this.vertical}/ignore-schedule/`;
            store.commit('setAdSetIgnoreSchedule', {
                id: adSetId,
                ignoreSchedule: status
            });

            store.commit('setIsLoading',true);
            this.$http.put(url + (status ? 'enabled' : 'disabled'))
                .then((data) => {
                    if (get(data, 'body.success') !== true) {
                        store.commit('setAdSetIgnoreSchedule', {
                            id: adSetId,
                            ignoreSchedule: !status
                        });
                    }
                    store.commit('setIsLoading', false);
                    this.fetchAllLiveAdSets();
                })
                .catch((error) => {
                    store.commit('setAdSetIgnoreSchedule', {
                        id: adSetId,
                        ignoreSchedule: !status
                    });

                    store.commit('setIsLoading', false);
                    this.fetchAllLiveAdSets();
                    this.manageErrors(error);
                });
        },

        changeBidStatus: function (bidId) {
            store.dispatch('changeBidStatus', bidId)
                .catch(({response}) => {
                    response.body = response.data; //lost in promise.reject
                    this.manageErrors(response);
                })
        },

        /* Utils */
        formatDateRange: function (start_date, end_date) {
            let dateRange = start_date ? this.dateFormatter(start_date) : '';
            dateRange += end_date ? ' - ' + this.dateFormatter(end_date) : '';

            return dateRange === '' ? 'None' : dateRange;
        },

        canCreateAdSet: function() {
            if (this.campaign.is_advertiser_edit_blocked && !this.hasRole(['staff', 'engineer'])) {
                return false
            }

            return this.canEditWithSelect(this.campaign.blnBankrateSelect)
        },

        setSortBy: function (criteria) {
            if (this.sortBy === criteria) {
                this.orderBy = this.orderBy === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortBy = criteria;
                this.orderBy = 'asc';
            }
        },

        showSortBy: function (criteria, order) {
            return this.sortBy === criteria && this.orderBy === order;
        },

        kFormatter: function (num) {
            return num > 999 ? (num / 1000).toFixed(1) + 'k' : num;
        },

        numberFormatter: function (num) {
            num = (num + '').replace(/[^0-9+\-Ee.]/g, '');
            return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ","); //thousands separator
        },

        dateFormatter: function (date) {
            return moment(date).format('MM/DD/YYYY');
        },

        shouldShowAdSet(adset) {
            return this.featureFlags.ad_set.phone ||
                (!this.featureFlags.ad_set.phone && Number(get(adset, 'type.id', null)) !== 2);
        },

        fetchAllLiveAdSets() {
            const url = `/api/campaign/${this.campaignId}/liveAdSets`;
            this.isLoadingAllLiveAdSets = true;
            this.$http.get(url).then((response) => {
                this.liveAdSets = response.body.liveAdSets;
                this.isLoadingAllLiveAdSets = false;
            }).catch((error) => {
                console.log(error);
                this.isLoadingAllLiveAdSets = false;
            })
        },

        isLive(adSetId) {
            return this.liveAdSets?.some(x => x.id === adSetId);
        },

        isTestMode(adSetId) {
            return  this.liveAdSets?.some(x => x.testMode && x.id === adSetId);
        },
    },

    filters: {
        budgetIntervalLabel: function (value) {
            const budgetIntervals = {
                1: 'Weekly',
                8: 'Daily',
                9: 'Open'
            };

            return budgetIntervals[value];
        }
    },
    mounted() {
        if(this.showLiveStatus) {
            this.fetchAllLiveAdSets()
        }
    }
}
</script>

